import Component from './Component';
import GlobalMessageComponent from './GlobalMessageComponent';
import ModalComponent from './ModalComponent';
import SelectComponent from './SelectComponent';
import AddToCartComponent from './AddToCartComponent';
import TagManagerComponent from './TagManagerComponent';
import FormComponent from './FormComponent';

export default class WishlistPopupComponent extends Component {
    get SELECTORS() {
        return {
            html: 'html',
            popup: '#wishlistPopup',
            product: '.js-article',
            quantity: '.js-quantity',
            wishlistItem: '.wishlist__item',
            miniCartItem: '.minicart-panel__item',
            cartItem: '.cart-item',
            recipeContainer: '.js-recipe-products .glide__slide:not(.glide__slide--clone) ',
            orderEntry: '.order-entry',
            addToWishlist: '.js-addToWishlist',
            saveToWishlist: '.js-saveToWishlist',
            header: 'header',
            imageUrl: '.js-article-image',
            buyOptionId: '#dropdownProductThickness-',
            weightChoiceId: '#dropdownProductWeight-',
            container: '.wishlist-popup__container',
            chooseWishlists: '#chooseWishlist option',
            wishlistAlreadyAdded : '.wishlist-popup__content--item',
            weightOptionsContainer: '.hit__weight-options--container'
        }
    }

    get CLASSES() {
        return {
            hide: 'hide'
        }
    }

    get DATA() {
        return {
            code: 'data-code',
            entryCode: 'data-entrycode',
            wishlist: 'data-wishlist',
            logged: 'data-logged',
            popupCode: 'data-wishlistPopup-code',
            popupQuantity: 'data-wishlistPopup-quantity',
            popupWeightChoice: 'data-wishlistPopup-weightChoice',
            popupBuyOption: 'data-wishlistPopup-buyOption',
            color: 'data-color',
            page: 'data-page',
            CSRFToken: 'data-csrftoken',
            order: 'data-ordercode',
            brand: 'data-brand',
            name: 'data-name',
            options: 'data-options',
            wishListProductKey: 'onWishlistPopup'
        }
    }

    get PAGES() {
        return {
            minicart: 'minicart',
            cart: 'cart',
            onlineOrders: 'onlineOrders',
            listing: 'listing',
            magazine: 'magazine'
        }
    }

    get TEMPLATES() {
        return {
            templateId: 'wishlistPopup--template'
        }
    }

    constructor() {
        super();
        this.ModalComponent = new ModalComponent();
        this.SelectComponent = new SelectComponent();
        this.AddToCartComponent = new AddToCartComponent();
        this.TagManagerComponent = new TagManagerComponent();
        this.GlobalMessageComponent = new GlobalMessageComponent();
        this.FormComponent = new FormComponent();
        this.token = this.getDataAttribute(this.SELECTORS.html, this.DATA.CSRFToken);
    }

    getAllWishlist(element, isCart, product) {
        const popup = document.querySelector(this.SELECTORS.popup),
        d = new Date(),
        day = d.getDate(),
        month = d.getMonth() + 1,
        year = d.getFullYear();

        let sku, quantity, buyOption, weightChoice, entryCode,
        titlePopup = false;

        fetch(this.endpoints.WISHLIST_GET_ALL.url, {
            headers: {
                'Content-Type': 'application/json', // This is set on request
                'X-Requested-With': 'XMLHttpRequest'
            }
        }).then((response) => response.json()).then((data) => {
            if (data.showPopUp) {
                this.ModalComponent.openModal(document.getElementById('sessionTimeoutPopup'));
            } else {
                if (!isCart) {
                    sku = product.getAttribute(this.DATA.code);
                    entryCode = (product.getAttribute(this.DATA.entryCode) != null) ? product.getAttribute(this.DATA.entryCode) : '';
                    if(product.querySelector(this.SELECTORS.quantity) != null) {
                        quantity = Number(product.querySelector(this.SELECTORS.quantity).textContent) === 0 ? 1 : Number(product.querySelector(this.SELECTORS.quantity).textContent);
                    } else {
                        quantity = 1;
                    }
                    buyOption = (product.querySelector(this.SELECTORS.buyOptionId + sku) != null) ? product.querySelector(this.SELECTORS.buyOptionId + sku).value : '';
                    weightChoice = (product.querySelector(this.SELECTORS.weightChoiceId + sku) != null) ? product.querySelector(this.SELECTORS.weightChoiceId + sku).value : '';

                    for (var i=0; i<data.length; i++) {
                        data[i].containsProduct = false;
        
                        if(data[i].entries != null) {
                            for (var j=0; j<data[i].entries.length; j++) {
                                if (sku === data[i].entries[j].product.code) {
                                    const entryWeightChoice = {
                                        value: data[i].entries[j].weightChoice != null ? data[i].entries[j].weightChoice.order : null
                                    },
                                    entryBuyOption = {
                                        value: data[i].entries[j].buyOption != null ? data[i].entries[j].buyOption.order : null
                                    },
                                    sameProduct = this.AddToCartComponent.isSameOptions(product.querySelector(this.SELECTORS.weightChoiceId + sku),
                                                                                            product.querySelector(this.SELECTORS.buyOptionId + sku),
                                                                                            entryWeightChoice,
                                                                                            entryBuyOption);
                                    
                                    if (sameProduct) {
                                        data[i].containsProduct = true;
                                        titlePopup = true;
                                    }
                                }
                            }
                        }
                    }
                }
                const results = {
                    allWishlists: data,
                    titlePopup: titlePopup,
                    isCart: isCart,
                    day: day,
                    month: month,
                    year: year,
                    sku: sku,
                    entryCode: entryCode,
                    quantity: quantity,
                    buyOption: buyOption,
                    weightChoice: (weightChoice != 'null') ? weightChoice : 1,
                    isWishlistPage: element.classList.contains('wishlist-page') ? true : false,
                    oldWishlist: (element.closest(this.SELECTORS.wishlistItem) != null) ? element.closest(this.SELECTORS.wishlistItem).getAttribute(this.DATA.wishlist) : '',
                    title: (isCart === false) ? product.getAttribute(this.DATA.name) : '',
                    brand: (isCart === false) ? product.getAttribute(this.DATA.brand) : '',
                    imageUrl: (isCart === false && product.querySelectorAll(this.SELECTORS.imageUrl)[0] != null) ? product.querySelectorAll(this.SELECTORS.imageUrl)[0].src : ''
                }

                results.allWishlists.sort((a, b) => (b.preferred === true) - (a.preferred === true));
                this.renderMustache(this.TEMPLATES.templateId, popup, results);

                if(isCart) {
                    document.querySelector(this.SELECTORS.saveToWishlist).setAttribute(this.DATA.page,element.getAttribute(this.DATA.page));
                    if(element.getAttribute(this.DATA.page) === this.PAGES.onlineOrders) {
                        document.querySelector(this.SELECTORS.saveToWishlist).setAttribute(this.DATA.order,element.getAttribute(this.DATA.order));
                    }
                } 
                this.SelectComponent.createSelect();
                this.ModalComponent.openModal(popup);
            }
        })
    }

    saveProductToWishlist(element) {
        const popup = element.closest(this.SELECTORS.popup);
        let url, name, color, products = [];

        if (popup.querySelector('.js-accordion-container').classList.contains('accordion-opened')) {
            const inputName = popup.querySelector('input[name="name"]');
            
            if(this.existSameList(inputName.value)) {
                this.createErrorSameName(inputName);
                return false;
            } else if(inputName.value != '' && !inputName.classList.contains('error-field')) {
                url = this.endpoints.WISHLIST_CREATE_NEW.url,
                name = inputName.value,
                color = popup.querySelector('input[name="color"]:checked').value;
            } else {
                return false;
            }
        } else if (popup.querySelectorAll('option').length > 0) {
            url = this.endpoints.WISHLIST_ADD_PRODUCT.url,
            name = popup.querySelector('option:checked').textContent
            color = popup.querySelector('option:checked').getAttribute(this.DATA.color);
        } else {
            return false;
        }

        if (popup.querySelector(this.SELECTORS.container).getAttribute(this.DATA.popupCode)) {
            products.push({
                'productCode': popup.querySelector(this.SELECTORS.container).getAttribute(this.DATA.popupCode),
                'buyOption': popup.querySelector(this.SELECTORS.container).getAttribute(this.DATA.popupBuyOption),
                'weightChoice': popup.querySelector(this.SELECTORS.container).getAttribute(this.DATA.popupWeightChoice),
                'quantity': popup.querySelector(this.SELECTORS.container).getAttribute(this.DATA.popupQuantity)
            });
            const product = localStorage.getItem(this.DATA.wishListProductKey);
            if(product) {
                const container = document.createElement("div");
                container.innerHTML = product.trim();
                const restoredArticle = container.firstElementChild;
                this.TagManagerComponent.dataLayerAddToWishlistGA4([restoredArticle])
            }
            localStorage.removeItem(this.DATA.wishListProductKey);
        } else {
            var productItems;
            switch (element.getAttribute(this.DATA.page)) {
                case this.PAGES.onlineOrders:
                    const orderCode = element.getAttribute(this.DATA.order),
                        order = document.getElementById(orderCode);
                    productItems = order.querySelectorAll(this.SELECTORS.orderEntry);    
                    break;
                case this.PAGES.cart:
                    productItems = document.querySelectorAll(this.SELECTORS.cartItem);
                    break;
                case this.PAGES.magazine:
                    productItems = document.querySelectorAll(this.SELECTORS.recipeContainer + this.SELECTORS.product);
                    break;
                default:
                    productItems = document.querySelectorAll(this.SELECTORS.miniCartItem);          
            }
            productItems.forEach(productToAdd => {
                const sku = productToAdd.getAttribute(this.DATA.code);
                products.push({
                    'productCode': sku,
                    'buyOption': (productToAdd.querySelector(this.SELECTORS.buyOptionId + sku) != null) ? productToAdd.querySelector(this.SELECTORS.buyOptionId + sku).value : '',
                    'weightChoice': (productToAdd.querySelector(this.SELECTORS.weightChoiceId + sku) != null) ? ((productToAdd.querySelector(this.SELECTORS.weightChoiceId + sku).value != 'null') ? productToAdd.querySelector(this.SELECTORS.weightChoiceId + sku).value : 1) : '',
                    'quantity': productToAdd.querySelector(this.SELECTORS.quantity) != null ? ((Number(productToAdd.querySelector(this.SELECTORS.quantity).textContent) != 0 ) ? Number(productToAdd.querySelector(this.SELECTORS.quantity).textContent) : 1) : 1
                });
            });
            this.TagManagerComponent.dataLayerAddToWishlistGA4(productItems);
        }

        const obj = {
            'params': products,
            'name':  name,
            'color': color
        };

        fetch(url, {
            method: 'post',
            body: JSON.stringify(obj),
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Content-Type': 'application/json', // This is set on request
                'CSRFToken': this.token, // This is set on request
                'Cookie': this.token // This is missing from request
            }
        }).then(
            (response) => {
                this.ModalComponent.closeModal();
                window.dispatchEvent(new CustomEvent('readyToLoadWishlistPage'));
                if(response.status === 406) {
                    this.GlobalMessageComponent.renderGlobalMessages("Hai raggiunto il numero massimo di prodotti inseribili alla wishlist", "danger")
                    return false;
                } else {
                    if (products.length > 1) {
                        this.GlobalMessageComponent.renderGlobalMessages('Prodotti inseriti correttamente nella lista da te scelta.', 'info');
                    } else {
                        this.GlobalMessageComponent.renderGlobalMessages('Prodotto inserito correttamente nella lista da te scelta.', 'info');
                    }
                    return true;
                }
            }
        );


    }

    existSameList(wishlistName){
        const allWishlistsName = [];

        document.querySelectorAll(this.SELECTORS.wishlistAlreadyAdded).forEach(e => {
            allWishlistsName.push(e.textContent.trim());
        }) 

        document.querySelectorAll(this.SELECTORS.chooseWishlists).forEach(e => {
            allWishlistsName.push(e.value.trim());
        })
        return allWishlistsName.some( (e) => { 
            return e === wishlistName.trim();
        });
    }

    createErrorSameName(input) {
        if(input.classList.contains('error-field')){
            input.previousSibling.remove();
        }
        this.FormComponent.createInputError(input, 'Esiste già una lista con questo nome')
    }

    bindEvents() {
        this.events.on('click', this.SELECTORS.addToWishlist, (e) => {
            const element = e.target.matches(this.SELECTORS.addToWishlist) ? e.target : e.target.closest(this.SELECTORS.addToWishlist);
            if (this.getDataAttribute(this.SELECTORS.header, this.DATA.logged) === 'true') {
                if ( element.getAttribute(this.DATA.page)  === this.PAGES.magazine || element.getAttribute(this.DATA.page)  === this.PAGES.minicart || element.getAttribute(this.DATA.page) === this.PAGES.cart || element.getAttribute(this.DATA.page) === this.PAGES.onlineOrders ) {
                    this.getAllWishlist(element, true);
                } else {
                    let product = e.target.closest(this.SELECTORS.product),
                    weightChoice = (product.querySelector(this.SELECTORS.weightChoiceId + product.getAttribute(this.DATA.code)) != null) ? product.querySelector(this.SELECTORS.weightChoiceId + product.getAttribute(this.DATA.code)).value : '',
                    lengthWeightChoice = (product.querySelector(this.SELECTORS.weightChoiceId + product.getAttribute(this.DATA.code)) != null) ?  product.querySelectorAll(this.SELECTORS.weightChoiceId + product.getAttribute(this.DATA.code) + ' option').length : 'undefined';

                    if(weightChoice == "null" && lengthWeightChoice > 2 && product.getAttribute(this.DATA.options)) {
                        if (product.getAttribute(this.DATA.page) === this.PAGES.listing) {
                            product.querySelector(this.SELECTORS.weightOptionsContainer).classList.remove(this.CLASSES.hide);
                        }
                        this.GlobalMessageComponent.renderGlobalMessages('Per aggiungere il prodotto alla wishlist è necessario selezionare la confezione.','danger');
                    } else {
                        this.getAllWishlist(element, false, product);
                        localStorage.setItem(this.DATA.wishListProductKey, product.outerHTML);
                    }
                }
            } else {
                this.ModalComponent.openModal(document.getElementById('loginModal'));
            }
        });

        this.events.on('click', this.SELECTORS.saveToWishlist, (e) => {
            const element = e.target.matches(this.SELECTORS.saveToWishlist) ? e.target : e.target.closest(this.SELECTORS.saveToWishlist);
            this.saveProductToWishlist(element);
        });
    }

    render() {
        this.log('render Wishlist Popup');
        this.bindEvents();       
    }
}
